"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _materialTable = _interopRequireWildcard(require("material-table"));

var _core = require("@material-ui/core");

var _styles = require("@material-ui/core/styles");

var _icons = require("@material-ui/icons");

var _sweetalert = _interopRequireDefault(require("sweetalert2"));

var _sweetalert2ReactContent = _interopRequireDefault(require("sweetalert2-react-content"));

var _translateTable = _interopRequireDefault(require("../../utils/translateTable"));

var _useGetRequest2 = _interopRequireDefault(require("../../hooks/useGetRequest"));

var _NotFound = _interopRequireDefault(require("../../components/NotFound"));

var _urls = require("../../utils/urls");

require("moment/locale/es");

require("../../index.css");

require("./styles.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

window.React = _react.default;
var useStyles = (0, _styles.makeStyles)(function () {
  return {
    fabFloatingButton: {
      bottom: 20,
      left: "auto",
      margin: 0,
      position: "fixed",
      right: 20,
      top: "auto",
      zIndex: 100
    },
    error: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      height: "100vh"
    },
    textError: {
      fontWeight: 300,
      fontSize: "1em"
    }
  };
});
var MySwal = (0, _sweetalert2ReactContent.default)(_sweetalert.default);

function FormList(props) {
  var _props$api;

  var classes = useStyles();

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      isLoading = _useState2[0],
      setIsLoading = _useState2[1];

  var _useGetRequest = (0, _useGetRequest2.default)("".concat((_props$api = props.api) !== null && _props$api !== void 0 ? _props$api : _urls.API_FULL, "/form-builders"), props.token),
      response = _useGetRequest.data,
      error = _useGetRequest.error,
      reload = _useGetRequest.mutate;

  var handleDelete = function handleDelete(id, name) {
    MySwal.fire({
      title: "Estas seguro que desea eliminar ".concat(name, "?"),
      text: "Esta acción es permanente!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "OK",
      cancelButtonText: "Cancelar"
    }).then( /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(result) {
        var _props$api2;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!result.isConfirmed) {
                  _context.next = 6;
                  break;
                }

                setIsLoading(true);
                _context.next = 4;
                return fetch("".concat((_props$api2 = props.api) !== null && _props$api2 !== void 0 ? _props$api2 : _urls.API_FULL, "/form-builders/").concat(id), {
                  method: "DELETE",
                  headers: {
                    Authorization: "Bearer ".concat(props.token)
                  }
                });

              case 4:
                reload();
                setIsLoading(false);

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());
    setIsLoading(false);
  };

  if (error) {
    return /*#__PURE__*/_react.default.createElement(_NotFound.default, null);
  }

  return /*#__PURE__*/_react.default.createElement(_core.Grid, {
    container: true
  }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true,
    xs: 12,
    style: {
      marginBottom: 64
    }
  }, /*#__PURE__*/_react.default.createElement(_materialTable.default, {
    style: {
      boxShadow: "none",
      borderBottomRightRadius: 15,
      borderBottomLeftRadius: 15
    },
    localization: _translateTable.default,
    isLoading: !response || isLoading,
    title: "",
    columns: [{
      title: "Nombre",
      field: "name"
    }, {
      title: "ID Form",
      field: "_id"
    }, {
      title: "Creado",
      field: "createdAt",
      type: "datetime"
    }, {
      title: "Actualizado",
      field: "updatedAt",
      type: "datetime"
    }],
    data: response,
    options: {
      actionsColumnIndex: -1,
      actionsCellStyle: {
        paddingLeft: 16
      },
      headerStyle: {
        fontWeight: "bold"
      }
    },
    components: {
      Toolbar: function Toolbar(props) {
        return /*#__PURE__*/_react.default.createElement("div", {
          style: {
            display: "flex",
            justifyContent: "space-between"
          }
        }, /*#__PURE__*/_react.default.createElement("div", {
          style: {
            display: "flex",
            paddingLeft: "10px"
          }
        }), /*#__PURE__*/_react.default.createElement(_materialTable.MTableToolbar, props));
      }
    },
    actions: [{
      icon: function icon() {
        return /*#__PURE__*/_react.default.createElement(_icons.EditRounded, null);
      },
      tooltip: "Editar",
      onClick: function onClick(e, row) {
        var url = "/form-builder/edit/".concat(row._id);
        return props.history ? props.history.push(url) : props.navigate(url);
      }
    }, {
      icon: function icon() {
        return /*#__PURE__*/_react.default.createElement(_icons.VisibilityRounded, null);
      },
      tooltip: "Ver",
      onClick: function onClick(e, row) {
        var url = "/form-builder/consumption/".concat(row._id);
        return props.history ? props.history.push(url) : props.navigate(url);
      }
    }, {
      icon: function icon() {
        return /*#__PURE__*/_react.default.createElement(_icons.DeleteRounded, null);
      },
      tooltip: "Eliminar",
      onClick: function onClick(e, row) {
        return handleDelete(row._id, row.name);
      }
    }]
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: classes.fabFloatingButton
  }, /*#__PURE__*/_react.default.createElement(_core.Fab, {
    color: "primary",
    "aria-label": "add",
    onClick: function onClick() {
      var url = "/form-builder/create";
      return props.history ? props.history.push(url) : props.navigate(url);
    }
  }, /*#__PURE__*/_react.default.createElement(_icons.Add, null))));
}
/* FormList.propTypes = {
  token: PropTypes.string.isRequired,
}; */


var _default = FormList;
exports.default = _default;